import { View, Text } from '@react-pdf/renderer';
import { tableStyle } from './style';
import { Duration } from 'luxon';
import { BaseUserOnProject } from '..';

export interface TableTimeLog {
    id: string;
    logStarted: string;
    description: string;
    duration: Duration;
    percentage: number;
}

interface ITable extends BaseUserOnProject {
    timeLogs: TableTimeLog[];
    totalTime: string;
}

export const Table = ({ timeLogs, projectName, memberName, memberLastName, totalTime }: ITable) => {
    return (
        <View style={tableStyle.table}>
            <View fixed>
                <Text style={tableStyle.tableHeading}>{`${projectName} - ${memberName} ${memberLastName}`}</Text>
                <View style={tableStyle.tableHeaderRow}>
                    <Text style={tableStyle.headerDate}>Date</Text>
                    <Text style={tableStyle.headerDescription}>Description</Text>
                    <Text style={tableStyle.headerTime}>Time</Text>
                    <Text style={tableStyle.headerPercentage}>Percentage</Text>
                </View>
            </View>
            {timeLogs.map(tl => (
                <View key={tl.id} style={tableStyle.tableRow}>
                    <View style={tableStyle.rowDateCell}>
                        <Text style={tableStyle.rowDate}>{tl.logStarted}</Text>
                    </View>
                    <View style={tableStyle.rowDescriptionCell}>
                        <Text style={tableStyle.rowDescription} hyphenationCallback={word => word.split('')}>
                            {tl.description}
                        </Text>
                    </View>
                    <View style={tableStyle.rowTimeCell}>
                        <Text style={tableStyle.rowTime}>{tl.duration.toFormat('hh:mm:ss')}</Text>
                    </View>
                    <View style={tableStyle.rowPercentageCell}>
                        <Text style={tableStyle.rowPercentage}>{`${tl.percentage}%`}</Text>
                    </View>
                </View>
            ))}
            <View style={tableStyle.totalRow}>
                <Text>Total Time:</Text>
                <Text>{totalTime}</Text>
            </View>
        </View>
    );
};
